import React, { useEffect, useState, PureComponent } from "react";
import NavBar from "../../components/Navbar/Navbar";
// import isAccessTokenGeldig from "../../utils/auth";
// import axiosInstance from "../../utils/axiosApi";
import { useKeycloak } from "@react-keycloak/web";
import { Table } from "@mui/material";


const UserAttributes = () => {


  const [currentUser, setCurrentUser] = useState({
    username: "",
    groups: [],
    first_name: "",
    last_name: "",
    email: "",
    last_login: "",
  });

  const { keycloak, initialized } = useKeycloak();

  if (!!keycloak.authenticated){
    localStorage.setItem("access_token", keycloak.token)
    console.log("user is authenticated, setting the access token");
  };
  if (!keycloak.authenticated){
    console.log("user is NOT authenticated, setting null token in local storage");
  };
  // const username = localStorage.getItem("current_user");
  const username = localStorage.getItem("username");

  const retrieveCurrentUser = async () => {
   
    if (username === null) {
      console.log("forced to be here")
    }

    try {
      // await axiosInstance.get(`users/${username}`).then((response) => {
      //   setCurrentUser(response.data);

      //   // Sla user op in lokale opslag
      //   localStorage.setItem(
      //     "current_user_data",
      //     JSON.stringify(response.data)
      //   );
      // });
      console.log("forced to be here2")
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    // isAccessTokenGeldig();
    retrieveCurrentUser();
  }, []);

  return (
    <>
      <NavBar />
      {/* <div className="hidden xl:flex items-center space-x-5">
    <div className="hover:text-gray-200">
    </div>
    </div> */}
 


    <div>
                
      <hr />
          <div
            //   style={{
            //       backgroundImage: `url(${background_saved_image})`,backgroundSize: 'cover' , backgroundRepeat: 'no-repeat', width: '100%', height: '950px', color: 'blue'
            //   }}
              >
             <strong> {!!keycloak.authenticated && (<strong>Welcome ({keycloak.tokenParsed.preferred_username})</strong>)}</strong>
              <div className="container has-text-centered">
                  <h1 className="title is-4" style={{ marginBottom: "2rem" }}>
                
                   
                        {
                        !!keycloak.authenticated && (
                        <div>Welcome <br></br>
                        <Table border="1" align="left">
                            <tr>
                                <td>preferred_username</td>
                                <td>{keycloak.tokenParsed.preferred_username}</td>
                            </tr>
                            <tr>
                                <td>family_name</td>
                                <td>{keycloak.tokenParsed.family_name}</td>
                            </tr>
                            <tr>
                                <td>given_name</td>
                                <td>{keycloak.tokenParsed.given_name}</td>
                            </tr>
                            <tr>
                                <td>email</td>
                                <td>{keycloak.tokenParsed.email}</td>
                            </tr>
                            <tr>
                                <td>name</td>
                                <td>{keycloak.tokenParsed.name}</td>
                            </tr>
                            <tr>
                                <td>email_verified</td>
                                <td>{keycloak.tokenParsed.email_verified}</td>
                            </tr>
                            <tr>
                                <td>scope</td>
                                <td>{keycloak.tokenParsed.scope}</td>
                            </tr>
                            <tr>
                                <td>allowed_origins</td>
                                <td>{keycloak.tokenParsed.allowed_origins}</td>
                            </tr>
                            <tr>
                                <td>exp</td>
                                <td>{keycloak.tokenParsed.exp}</td>
                            </tr>
                            <tr>
                                <td>iat</td>
                                <td>{keycloak.tokenParsed.iat}</td>
                            </tr>
                            <tr>
                                <td>auth_time</td>
                                <td>{keycloak.tokenParsed.auth_time}</td>
                            </tr>
                            <tr>
                                <td>jti</td>
                                <td>{keycloak.tokenParsed.jti}</td>
                            </tr>
                            <tr>
                                <td>iss</td>
                                <td>{keycloak.tokenParsed.iss}</td>
                            </tr>
                            <tr>
                                <td>aud</td>
                                <td>{keycloak.tokenParsed.aud}</td>
                            </tr>
                            <tr>
                                <td>sub</td>
                                <td>{keycloak.tokenParsed.sub}</td>
                            </tr>
                            <tr>
                                <td>typ</td>
                                <td>{keycloak.tokenParsed.typ}</td>
                            </tr>
                            <tr>
                                <td>iat</td>
                                <td>{keycloak.tokenParsed.iat}</td>
                            </tr>
                            <tr>
                                <td>azp</td>
                                <td>{keycloak.tokenParsed.azp}</td>
                            </tr>
                            <tr>
                                <td>nonce</td>
                                <td>{keycloak.tokenParsed.nonce}</td>
                            </tr>
                        </Table>
                    
                        {/* resource_access: {keycloak.tokenParsed.resource_access}<br></br> */}
                        {/* realm_access: {keycloak.tokenParsed.realm_access}<br></br> */}
              
                        </div>
                        )
                        }
                        
                    
                  </h1>
                  <h2 className="subtitle is-4" style={{color: 'black'}}>
                    Pand Onderhoud Systeem 
                    <br></br>
                    {!keycloak.authenticated &&(<h3 style={{color: 'black'}}>Please click login button to, authenticate with keycloak to view the resources</h3>)}
                  </h2>
              </div>
          </div>
    </div>
   


      {/* <section className="hero is-light is-fullheight">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-1" style={{ marginBottom: "2rem" }}>
              <strong>
              {!!keycloak.authenticated && (<strong>Welcome ({keycloak.tokenParsed.preferred_username})</strong>)}
              </strong>
            </h1>
            <h2 className="subtitle is-4">
              Pand Onderhoud Systeem (<strong>v0.1</strong>)
              <br></br>
              {!keycloak.authenticated &&(<h3>Please click login button to, authenticate with keycloak to view the resources</h3>)}
            </h2>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default UserAttributes;
